let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("93Hs0")).then(() => parcelRequire('8pGkY'));